// extracted by mini-css-extract-plugin
export default {"button":"styles_button__f4zrC","profile":"styles_profile__qcHFQ","triangle":"styles_triangle__Em7vU","content":"styles_content__kGI21","group":"styles_group__JfrjE"};